import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'components/common';
import connect from 'stores/connect';
import { EventDefinitionsActions, EventDefinitionsStore } from 'stores/event-definitions/EventDefinitionsStore';

import CorrelationForm from './CorrelationForm';
import EventsLicenseStatus from './EventsLicenseStatus';
import { EventsLicenseStore, EventsLicenseActions } from './EventsLicenseStore';

class CorrelationFormContainer extends React.Component {
  static propTypes = {
    action: PropTypes.oneOf(['create', 'edit']).isRequired,
    eventDefinition: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    eventDefinitions: PropTypes.object,
    eventsLicenseStatus: PropTypes.object.isRequired,
    entityTypes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    eventDefinitions: undefined,
  };

  componentDidMount() {
    EventDefinitionsActions.listAll();
    EventsLicenseActions.getLicenseStatus();
  }

  render() {
    const { eventDefinitions, eventsLicenseStatus, ...otherProps } = this.props;
    const isLoading = !eventDefinitions.all || eventsLicenseStatus.loading;

    if (isLoading) {
      return <Spinner text="Loading Event Definitions..." />;
    }

    return (
      <>
        <EventsLicenseStatus licenseStatus={eventsLicenseStatus} />
        <CorrelationForm {...otherProps} eventDefinitions={eventDefinitions.all} />
      </>
    );
  }
}

export default connect(CorrelationFormContainer, {
  eventDefinitions: EventDefinitionsStore,
  eventsLicenseStatus: EventsLicenseStore,
});
